export const LOAD_FEEDBACK_REQUEST = 'CandidateFeedbackPage/LOAD_FEEDBACK_REQUEST';
export const LOAD_FEEDBACK_SUCCESS = 'CandidateFeedbackPage/LOAD_FEEDBACK_SUCCESS';
export const LOAD_FEEDBACK_FAILURE = 'CandidateFeedbackPage/LOAD_FEEDBACK_FAILURE';
export const UPDATE_FEEDBACK_REQUEST = 'CandidateFeedbackPage/UPDATE_FEEDBACK_REQUEST';
export const UPDATE_FEEDBACK_SUCCESS = 'CandidateFeedbackPage/UPDATE_FEEDBACK_SUCCESS';
export const UPDATE_FEEDBACK_FAILURE = 'CandidateFeedbackPage/UPDATE_FEEDBACK_FAILURE';
export const LOAD_TEST_REQUEST = 'CandidateFeedbackPage/LOAD_TEST_REQUEST';
export const LOAD_TEST_SUCCESS = 'CandidateFeedbackPage/LOAD_TEST_SUCCESS';
export const LOAD_TEST_FAILURE = 'CandidateFeedbackPage/LOAD_TEST_FAILURE';
